import { combineReducers } from 'redux'

import { nftsProfile } from './nfts'
import { nftsListProfile } from './nftsList'
import { nftUsersProfile } from './nftUsers'

export const nftsReducer = combineReducers({
  nftsProfile,
  nftsListProfile,
  nftUsersProfile
})
